// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FRNZk","title":"Info_title__3SI0E","selects":"Info_selects__1RiZR","requiredAsterisk":"Info_requiredAsterisk__3GXVw"};